const PersonPrivate = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4209 13.9999C19.629 13.9999 20.6146 14.9525 20.6676 16.1475L20.6667 16.25H12.6667L12.6663 15.499L6.91916 15.4999C6.50557 15.4999 6.17029 15.8352 6.17029 16.2488V16.8265C6.17029 17.3621 6.3614 17.8802 6.70926 18.2876C7.96256 19.7553 9.92844 20.5011 12.6667 20.5011V19.75L19.3088 19.751C17.748 21.2569 15.5191 22.0011 12.6667 22.0011C9.52088 22.0011 7.13487 21.0959 5.56857 19.2617C4.98881 18.5827 4.67029 17.7193 4.67029 16.8265V16.2488C4.67029 15.0068 5.67714 13.9999 6.91916 13.9999H18.4209ZM20.1368 18.7512L12.6667 18.75V17.25L20.6455 17.2502C20.5847 17.7818 20.411 18.2935 20.1368 18.7512ZM12.6667 2C14.3025 2 15.7548 2.78547 16.667 3.99981L12.6667 4V3.5C10.7337 3.5 9.16675 5.067 9.16675 7C9.16675 8.933 10.7337 10.5 12.6667 10.5V10L16.6662 10.0012C15.754 11.215 14.302 12 12.6667 12C9.90532 12 7.66675 9.76142 7.66675 7C7.66675 4.23858 9.90532 2 12.6667 2ZM17.642 7.5007C17.5894 8.02919 17.4546 8.53347 17.2505 9.00053L12.6667 9V7.5L17.642 7.5007ZM17.2509 5.00046C17.4549 5.46754 17.5896 5.97182 17.6421 6.5003L12.6667 6.5V5L17.2509 5.00046Z"
        fill="#DD442C"
      />
    </svg>
  );
};
export default PersonPrivate;
